/* eslint-disable import/order */
/* eslint-disable react/prop-types */

import React from 'react';
import PropTypes from 'prop-types';
import getRowClasses from './form/fields/editor/GetRowClasses';
import getColumnClasses from './form/fields/editor/GetColumnClasses';
import Error from '@components/common/form/fields/Error';
import { useFormContext } from '@components/common/form/Form';
import { useLanguage } from './locale/useLanguage';
function Paragraph(_ref) {
  var {
    data
  } = _ref;
  return /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: data.text
    }
  });
}
Paragraph.propTypes = {
  data: PropTypes.shape({
    text: PropTypes.string.isRequired
  }).isRequired
};
function Header(_ref2) {
  var {
    data
  } = _ref2;
  var Tag = "h".concat(data.level);
  return /*#__PURE__*/React.createElement(Tag, null, data.text);
}
Header.propTypes = {
  data: PropTypes.shape({
    level: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired
  }).isRequired
};
function List(_ref3) {
  var {
    data
  } = _ref3;
  return /*#__PURE__*/React.createElement("ul", null, data.items.map((item, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, item)));
}
List.propTypes = {
  data: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.string).isRequired
  }).isRequired
};
function Quote(_ref4) {
  var {
    data
  } = _ref4;
  return /*#__PURE__*/React.createElement("blockquote", null, /*#__PURE__*/React.createElement("p", null, "\"", data.text, "\""), data.caption && /*#__PURE__*/React.createElement("cite", null, "- ", data.caption));
}
Quote.propTypes = {
  data: PropTypes.shape({
    text: PropTypes.string.isRequired,
    caption: PropTypes.string
  }).isRequired
};
function Image(_ref5) {
  var {
    data
  } = _ref5;
  var {
    file,
    caption,
    withBorder,
    withBackground,
    stretched,
    url
  } = data;
  var imageStyles = {
    border: withBorder ? '1px solid #ccc' : 'none',
    backgroundColor: withBackground ? '#f9f9f9' : 'transparent',
    width: stretched ? '100%' : 'auto',
    display: 'block',
    maxWidth: '100%',
    margin: '0 auto' // Center the image if not stretched
  };
  var imageElement = /*#__PURE__*/React.createElement("img", {
    src: file.url,
    alt: caption || 'Image',
    style: imageStyles
  });
  return /*#__PURE__*/React.createElement("div", null, url ? /*#__PURE__*/React.createElement("a", {
    href: url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, imageElement) : imageElement, caption && /*#__PURE__*/React.createElement("p", {
    style: {
      textAlign: 'center',
      marginTop: '10px'
    }
  }, caption));
}
Image.propTypes = {
  data: PropTypes.shape({
    file: PropTypes.shape({
      url: PropTypes.string.isRequired
    }).isRequired,
    caption: PropTypes.string,
    withBorder: PropTypes.bool,
    withBackground: PropTypes.bool,
    stretched: PropTypes.bool,
    url: PropTypes.string
  }).isRequired
};
function RawHtml(_ref6) {
  var {
    data
  } = _ref6;
  return /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: data.html
    }
  });
}
RawHtml.propTypes = {
  data: PropTypes.shape({
    html: PropTypes.string.isRequired
  }).isRequired
};
function RenderEditorJS(_ref7) {
  var {
    blocks,
    editorStyle
  } = _ref7;
  var {
    isAr
  } = useLanguage();
  return /*#__PURE__*/React.createElement("div", {
    className: "self-stretch relative justify-start text-[#cccccc]  font-normal md:text-[2rem] ".concat(isAr ? 'pl-[1.5rem] !font-[300]' : 'pr-[1.5rem]', "  md:leading-[2.6rem] ").concat(editorStyle)
  }, blocks.map((block, index) => {
    switch (block.type) {
      case 'paragraph':
        return /*#__PURE__*/React.createElement(Paragraph, {
          key: index,
          data: block.data
        });
      case 'header':
        return /*#__PURE__*/React.createElement(Header, {
          key: index,
          data: block.data
        });
      case 'list':
        return /*#__PURE__*/React.createElement(List, {
          key: index,
          data: block.data
        });
      case 'image':
        return /*#__PURE__*/React.createElement(Image, {
          key: index,
          data: block.data
        });
      case 'quote':
        return /*#__PURE__*/React.createElement(Quote, {
          key: index,
          data: block.data
        });
      case 'raw':
        return /*#__PURE__*/React.createElement(RawHtml, {
          key: index,
          data: block.data
        });
      default:
        return null;
    }
  }));
}
RenderEditorJS.propTypes = {
  blocks: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    data: PropTypes.object.isRequired
  })).isRequired
};
export default function Editor(_ref8) {
  var _context$fields;
  var {
    rows,
    editorStyle,
    error,
    label,
    name,
    value
  } = _ref8;
  var context = useFormContext();
  var field = context === null || context === void 0 || (_context$fields = context.fields) === null || _context$fields === void 0 ? void 0 : _context$fields.find(f => f.name && f.name === name);
  var fieldError = error || (field ? field.error : undefined);
  var displayRows = rows || (() => {
    var parsedValue = value;
    if (typeof value === 'string' && value.trim().length > 0) {
      try {
        parsedValue = JSON.parse(value);
      } catch (e) {
        parsedValue = [];
      }
    }
    return parsedValue || [];
  })();
  return /*#__PURE__*/React.createElement("div", {
    className: "editor__html ".concat(editorStyle, " form-field-container ").concat(fieldError ? 'has-error' : '')
  }, label && /*#__PURE__*/React.createElement("label", {
    htmlFor: "description"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "editor ".concat(editorStyle)
  }, displayRows === null || displayRows === void 0 ? void 0 : displayRows.map((row, index) => {
    var rowClasses = getRowClasses(row.size);
    return /*#__PURE__*/React.createElement("div", {
      className: "row__container ".concat(editorStyle, "  grid md:").concat(rowClasses, " grid-cols-1 gap-8"),
      key: index
    }, row === null || row === void 0 ? void 0 : row.columns.map((column, index) => {
      var _column$data, _column$data2;
      var columnClasses = getColumnClasses(column.size);
      return /*#__PURE__*/React.createElement("div", {
        className: "column__container md:".concat(columnClasses, " col-span-1"),
        key: index
      }, ((_column$data = column.data) === null || _column$data === void 0 ? void 0 : _column$data.blocks) && /*#__PURE__*/React.createElement(RenderEditorJS, {
        blocks: (_column$data2 = column.data) === null || _column$data2 === void 0 ? void 0 : _column$data2.blocks,
        editorStyle: editorStyle
      }));
    }));
  })), /*#__PURE__*/React.createElement(Error, {
    error: fieldError
  }));
}
Editor.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape({
    size: PropTypes.number.isRequired,
    columns: PropTypes.arrayOf(PropTypes.shape({
      size: PropTypes.number.isRequired,
      // eslint-disable-next-line react/forbid-prop-types
      data: PropTypes.object
    })).isRequired
  })),
  editorStyle: PropTypes.string,
  error: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
};
Editor.defaultProps = {
  rows: undefined,
  editorStyle: '',
  error: undefined,
  label: undefined,
  name: undefined,
  value: undefined
};